import styled from 'styled-components/macro';
import { down } from 'modules/_shared/styles/breakpoints';

const ResourceContainer = styled.div`
  display: grid;
  grid-template-columns: 65% 35%;
  grid-template-rows: auto;
  grid-template-areas: 'description aside';
  ${down('tablet')} {
    display: block;
  }

  & > div:nth-of-type(1) {
    grid-area: description;
    padding-right: 15px;

    li {
      :not(:last-child) {
        margin: 0 0 16px 0;
      }
    }
  }

  & > div:nth-of-type(2) {
    grid-area: aside;
  }

  & > div:nth-of-type(n + 3) {
    grid-column: 1 / 3;
    margin-top: 80px;
  }
`;

export default { ResourceContainer };
